import { LOCAL_STORAGE_KEY } from 'configuration/environment'

export const setJwtToken = token => localStorage.setItem(LOCAL_STORAGE_KEY, token);
export const getJwtToken = () => localStorage.getItem(LOCAL_STORAGE_KEY);